import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { EventProfilePage } from '../event-profile/event-profile';

@Component({
  selector: 'page-news',
  templateUrl: 'news.html',
})
export class NewsPage {

  event: any;
  client: any;

  constructor(public navCtrl: NavController, public navParams: NavParams) {}

  ngOnInit() {
    this.event = this.navParams.get('event');
    this.client = this.navParams.get('client');
  }

  viewProfile() {
    this.navCtrl.push(EventProfilePage, { client: this.client, event: this.event });
  }
}



// WEBPACK FOOTER //
// ./src/pages/news/news.ts